import { Box, Chip, Divider, styled, TextField } from "@mui/material"

export const ChipContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    width: "100%",
}))

export const FilterContainer = styled(Box)(() => ({
    width: "100%",
}))

export const CategoryTitle = styled(Box)(({ theme }) => ({
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "1.666em",
    letterSpacing: "-1%",
    color: theme.palette.common.black,
    marginBottom: "4px",
}))

export const StyledChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== "chipColor" && prop !== "active",
})<{ active?: boolean; chipColor?: string }>(({ theme, active, chipColor }) => {
    // Default color is theme's primary
    const defaultColor = theme.palette.primary.main

    // Use the provided color or default
    const color = chipColor ?? defaultColor

    // Determine if color is dark for better contrast
    // This works for HEX colors (#RRGGBB)
    const getContrastText = (bgColor: string) => {
        // Handle non-hex colors safely
        if (bgColor.length === 0 || !bgColor.startsWith("#")) {
            return theme.palette.getContrastText(theme.palette.primary.main)
        }

        try {
            // Parse hex color to RGB
            const r = parseInt(bgColor.slice(1, 3), 16)
            const g = parseInt(bgColor.slice(3, 5), 16)
            const b = parseInt(bgColor.slice(5, 7), 16)

            // Calculate luminance - standard formula for brightness perception
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

            // Return white for dark colors, black for light colors
            return luminance > 0.5
                ? theme.palette.common.black
                : theme.palette.common.white
        } catch (e) {
            // Fallback to theme's contrast function
            return theme.palette.getContrastText(theme.palette.primary.main)
        }
    }

    const textColor = active ?? false ? getContrastText(color) : color

    return {
        fontWeight: 400,
        fontSize: "13px",
        lineHeight: "1.384em",
        letterSpacing: "-1%",
        borderRadius: "100px",
        height: "auto",
        padding: "4px 4px",
        "& .MuiChip-label": {
            padding: "0 10px",
        },
        ...(active ?? false
            ? {
                  backgroundColor: color,
                  color: textColor,
                  border: `1px solid ${color}`,
                  "&:hover": {
                      backgroundColor: "#1D3233",
                  },
              }
            : {
                  backgroundColor: "transparent",
                  color,
                  border: `1px solid ${color}`,
              }),
    }
})

export const StyledDivider = styled(Divider)(() => ({
    height: "20px",
    margin: "auto 0",
    alignSelf: "center",
}))

export const StyledTextField = styled(TextField)(() => ({
    "& .MuiOutlinedInput-root": {
        height: "52px",
        padding: "6px 8px",
    },
    "& .MuiInputBase-input": {
        padding: "8px 4px",
        height: "unset",
        display: "flex",
        alignItems: "center",
    },
}))

export const ChipsFlexContainer = styled(Box)(() => ({
    display: "flex",
    flexWrap: "wrap",
    gap: "4px",
}))
